import React from 'react';

/* eslint-disable */
export const Error = () => (
    ''
);



// WEBPACK FOOTER //
// ./reactComponents/components/todoPlanner/error.jsx